import React from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import useField, { fieldPropTypes } from "./field";

const Fieldset = ({
    inline = false,
    children,
    ...props
}) => {
    const context = useFormContext();
    const {
        id,
        name,
        label,
        errors,
        required,
        fieldProps,
    } = useField(props, context, ["required", "onChange", "onInvalid"]);

    let FieldsetTag, LegendTag, fieldsetProps;

    if (inline) {
        FieldsetTag = "div";
        fieldsetProps = {
            "aria-labelledby": `${id}--fieldset-legend`,
        };
        LegendTag = "span";
    } else {
        FieldsetTag = "fieldset";
        fieldsetProps = {};
        LegendTag = "legend";
    }

    const scope = context.form.createScope(id, name, label, {
        required,
        LegendTag,
        bareName: props.name,
    });

    return (
        <scope.Provider value={scope.value} >
            <FieldsetTag
                {...(required && {"aria-required": true})}
                {...fieldsetProps}
                {...fieldProps}
                {...props}
            >
                { children }
            </FieldsetTag>
            { errors.elements}
        </scope.Provider>
    );
};

Fieldset.propTypes = {
    ...fieldPropTypes,
    inline: propTypes.bool,
    children: propTypes.any,
};

export default Fieldset;
